<template>
	<div>
		<form class="form border p-3">
			<div class="form-group">
				<label>Privacy Policy</label>
				<textarea name="privacypolicy" cols="30" rows="10" class="form-control" v-model="privacypolicy"></textarea>
			</div>
			<p class="text-center">
				<button type="button" class="btn btn-primary" @click="update('privacypolicy')">Update</button>
			</p>
		</form>
		<hr>
		<form class="form border p-3">
			<div class="form-group">
				<label>About</label>
				<textarea name="about" cols="30" rows="10" class="form-control" v-model="about"></textarea>
			</div>
			<p class="text-center">
				<button type="button" class="btn btn-primary" @click="update('about')">Update</button>
			</p>
		</form>
	</div>
</template>

<script>
import App from '@/App'

var static_id = 'lxFV5oB0aV6HhwiCt2gw';

export default {
  name: 'static',
  data: () => {
  	return {
  		url: App.data().url,
  		privacypolicy: '',
  		about: ''
  	}
  },
  mounted(){
  	App.methods.getData(this.url.privacypolicy, (data) => {
  		this.privacypolicy = data;
  	})
  	App.methods.getData(this.url.about, (data) => {
  		this.about = data;
  	})
  },
  methods: {
  	update(type){
  		if(type === 'privacypolicy'){
  			App.methods.updateData(this.url.privacypolicy, {id: static_id, privacy_policy: this.privacypolicy}, () => {
  				console.log('put privacy policy berhasil, coba cek dulu di firebase')
  			})
  		}else if(type === 'about'){
  			App.methods.updateData(this.url.about, {id: static_id, about: this.about}, () => {
  				console.log('put about berhasil, coba cek dulu di firebase')
  			})
  		}else{
  			console.log('type is no defined')
  		}
  	}
  }
}
</script>
